import styled from "styled-components"

export const $Div = styled.div`
height:38vh;
`
